module.exports = __webpack_public_path__ + "static/img/odnnary-navy-blue-scheme.b272041c.jpg";